import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useLayoutEffect,
} from 'react'
import { Okpd2 } from '../../../../../Org/Handbook/types'
import { OrganizationInfo } from '../../../../../Org/Home/types'

import { PurchaseLot, PurchaseLotItem } from '../../../../types'

import { CurrencyList, Okei } from '../../../../../Plans/Positions/Edit/types'

import LoadingIcon from '../../../../../../../components/LoadingIcon'
import HoverTooltip from '../../../../../../../components/HoverTooltip'

import { NumericFormat } from 'react-number-format'

type Props = {
    theme: string
    purchaseLotItem: PurchaseLotItem
    currencyList: CurrencyList[]
    purchaseLot: PurchaseLot
    okeiList: Okei[]
    purchaseAction: boolean
    orgData: OrganizationInfo | undefined
}

const PurchaseLotPositionTableRow: React.FC<Props> = (props) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    useLayoutEffect(() => {
        const el = textareaRef.current
        if (!el) return
        el.style.height = 'auto'
        requestAnimationFrame(() => {
            el.style.height = `${el.scrollHeight + 2}px`
        })
    }, [props.purchaseLotItem.additional_info])

    const [localValue, setLocalValue] = useState(
        props.purchaseLotItem.qty != null
            ? Number(props.purchaseLotItem.qty).toLocaleString('ru-RU', {
                  useGrouping: false,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 13,
              })
            : ''
    )

    // Если родитель изменяет значение, синхронизируем локальное состояние
    useEffect(() => {
        if (props.purchaseLotItem.qty != null) {
            setLocalValue(
                Number(props.purchaseLotItem.qty).toLocaleString('ru-RU', {
                    useGrouping: false,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 13,
                })
            )
        }
    }, [props.purchaseLotItem.qty])

    return (
        <div className="flex flex-col w-full h-fit">
            {/* строка документа */}

            <div
                className={`flex flex-row gap-1 mx-1 rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] items-start justify-center`}
                onContextMenu={(e) => {
                    e.preventDefault() // Отключает стандартное контекстное меню
                }}
            >
                <fieldset
                    className="flex flex-row w-full gap-1 items-start justify-center"
                    disabled={props.purchaseAction}
                >
                    <div className="flex w-10 h-full pt-1 items-start justify-center text-[#6A6A6A] dark:text-[#8A8A8A] cursor-pointer">
                        {props.purchaseLotItem.ordinal_number}
                    </div>
                    <div className="flex flex-1 items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                        <HoverTooltip
                            tooltipContent={
                                props.purchaseLotItem.additional_info
                            }
                            align="right"
                            valign="bottom"
                        >
                            <textarea
                                ref={textareaRef}
                                className={`form-textarea-table-row flex min-h-[26px] w-full p-1 px-2 rounded-md text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#181818]`}
                                maxLength={2000}
                                value={
                                    props.purchaseLotItem.additional_info ?? ''
                                }
                                rows={1}
                                readOnly
                            />
                        </HoverTooltip>
                    </div>
                    <div className="flex w-32 items-center justify-center">
                        <input
                            type="text"
                            inputMode="numeric"
                            lang="ru"
                            name="purchase_item_count"
                            className={`form-input-table-row rounded-md text-primary text-center w-full h-[28px] pr-1`}
                            style={{
                                colorScheme:
                                    props.theme == 'dark' ? 'dark' : 'light',
                            }}
                            maxLength={18}
                            value={localValue}
                            readOnly
                            disabled
                        />
                    </div>
                    <div className="flex flex-col w-32 items-center justify-center gap-1">
                        <HoverTooltip
                            tooltipText={
                                props.purchaseLotItem.okei_code == null
                                    ? 'Выбрать'
                                    : String(props.purchaseLotItem.okei_name)
                            }
                            align="left"
                            valign="bottom"
                        >
                            <select
                                className={`form-input-table-row px-2 rounded-md w-full h-[28px]`}
                                value={props.purchaseLotItem.okei_code ?? ''}
                            >
                                <option
                                    className="text-[#6A6A6A] dark:text-[#8A8A8A]"
                                    value=""
                                >
                                    {props.purchaseLotItem.okei_code == null
                                        ? 'Выбрать'
                                        : ''}
                                </option>

                                {props.okeiList.map((item, index) => (
                                    <option key={index} value={item.code}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </HoverTooltip>
                    </div>
                    <div className="flex w-28 items-center justify-center text-center">
                        <HoverTooltip
                            tooltipContent={`${props.purchaseLotItem.okpd2_code} - ${props.purchaseLotItem.okpd2_name}`}
                            align="left"
                            valign="bottom"
                        >
                            <input
                                data-autocomplete="okpd2"
                                type="text"
                                className={`form-input-table-row flex pl-2 pr-9 w-full h-[28px] rounded-md bg-[#181818] text-[#181818] dark:text-[#FFFFFF]`}
                                value={props.purchaseLotItem.okpd2_code ?? ''}
                                readOnly
                            />
                        </HoverTooltip>
                    </div>
                    <div className="flex w-28 items-center justify-center text-center">
                        <HoverTooltip
                            tooltipContent={`${props.purchaseLotItem.okved2_code} - ${props.purchaseLotItem.okved2_name}`}
                            align="left"
                            valign="bottom"
                        >
                            <input
                                data-autocomplete="okved2"
                                type="text"
                                className={`form-input-table-row flex pl-2 pr-9 w-full h-[28px] rounded-md bg-[#181818] text-[#181818] dark:text-[#FFFFFF]`}
                                value={props.purchaseLotItem.okved2_code ?? ''}
                                readOnly
                            />
                        </HoverTooltip>
                    </div>
                </fieldset>
            </div>
        </div>
    )
}

export default PurchaseLotPositionTableRow
